import { useQuery } from 'react-query';
import { addMinutes, isBefore } from 'date-fns';

import ActivityService from '../../../services/ActivityService';
import { ACTIVITY } from '../../constants/queryDefinition';
import { localStorageService } from '../../../services/StorageService';
import LOCALSTORAGE from '../../constants/localStorage';
import {
  LOCALSTORAGE_EXPIRY_MINUTES,
  LOCALSTORAGE_METADATA
} from './constants/paymentOnHold';

const activityService = ActivityService.get();

const usePaymentsOnHoldMetadata = () => {
  const localStoragePaymentsOnHold = localStorageService.getItem(
    LOCALSTORAGE.PAYMENTS_ON_HOLD
  );

  let localStoragePaymentsOnHoldMetadata;
  if (
    localStoragePaymentsOnHold?.[LOCALSTORAGE_METADATA] &&
    isBefore(new Date(), new Date(localStoragePaymentsOnHold.expiryTime))
  ) {
    localStoragePaymentsOnHoldMetadata =
      localStoragePaymentsOnHold[LOCALSTORAGE_METADATA];
  }

  const queryPaymentOnHoldSummary = async () => {
    const serviceResponse = await activityService.getPaymentsOnHoldMetadata();
    return serviceResponse;
  };

  const response = useQuery(
    ACTIVITY.GET_PAYMENT_ON_HOLD_METADATA.KEY,
    queryPaymentOnHoldSummary,
    {
      staleTime: ACTIVITY.GET_PAYMENT_ON_HOLD_METADATA.STALE_TIME,
      cacheTime: ACTIVITY.GET_PAYMENT_ON_HOLD_METADATA.STALE_TIME,
      enabled: true,
      retry: false,
      initialData: () => localStoragePaymentsOnHoldMetadata || undefined
    }
  );

  const data = response?.data;

  if (!localStoragePaymentsOnHoldMetadata && data) {
    const expiryTime = addMinutes(new Date(), LOCALSTORAGE_EXPIRY_MINUTES);
    localStorageService.setItem(LOCALSTORAGE.PAYMENTS_ON_HOLD, {
      expiryTime,
      [LOCALSTORAGE_METADATA]: data
    });
  }

  return data;
};

export default usePaymentsOnHoldMetadata;
